import { formatEther, parseEther } from "ethers/lib/utils";
import { ContractManager } from "./ContractManager";

/** @type {ContractManager} */
let manager

export function configureContractManager(
  tokenAddress,
  storefrontAddress,
  maticStorefrontAddress,
  wethAddress,
  network,
  infuraApiKey
) {
  if (manager) {
    throw new Error('already configured')
  }
  manager = new ContractManager(
    tokenAddress,
    storefrontAddress,
    maticStorefrontAddress,
    wethAddress,
    network,
    infuraApiKey
  )
}

export function getContractManager() {
  return manager
}
